import { render, staticRenderFns } from "./ReportImport.vue?vue&type=template&id=6f4f47c8&"
import script from "./ReportImport.vue?vue&type=script&lang=js&"
export * from "./ReportImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports